<template>

    <div class="flex flex-col">

        <div class="flex  w-full bg-gray-200 shadow-lg items-center mb-4">
            <div class="flex py-4 px-4 items-center  text-gray-700 hover:text-black cursor-pointer" @click="goBack">
                <ArrowLeftIcon class="mr-1 h-6 w-8 object-cover" ></ArrowLeftIcon>
                <p class="flex visible justify-center text-center">Back</p>
            </div>

            

        </div>

        <p class="ml-6 mr-2  text-xl font-bold  border-b-2 border-orange-500">User Info</p>

        <div v-if="loading" class="h-screen w-full">
            <div class="flex h-screen items-center">
                <vue-loaders
                name="ball-spin-fade-loader"
                color="#2a4365"
                class="flex m-auto my-4"
                scale="1"
                ></vue-loaders>
            </div>
        </div>

        <div v-else class="ml-6 mr-2 my-4">
            <div class="w-48 h-48 mb-4">
                <div class="group w-48 h-48 rounded-full overflow-hidden shadow-inner text-center bg-purple table cursor-pointer mx-auto">
                    <img :src="user.image_url" :alt="user.first_name" class="object-fill object-center w-48 h-48 visible group-hover:hidden" />
                </div>
            </div>
            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Title:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.title}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        First name:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.first_name}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Last name:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.last_name}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Other/Maiden name:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.other_name}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Email:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block tracking-wide text-gray-800 text-base font-medium">
                        {{user.email}}
                    </label>
                </div>

            </div>


            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Phone number:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.phone_number}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Occupation:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.occupation}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Address:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block tracking-wide text-gray-800 text-base font-medium">
                        {{user.home_address}}
                    </label>
                </div>

            </div>


            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Gender:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.gender}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Birth date:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.birthday | formatDate}}
                    </label>
                </div>

            </div>

            <div class="flex mb-2">

                <div class="flex-shrink  pr-3  md:mb-0">
                    <label class="block tracking-wide text-gray-600 text-base font-medium">
                        Marital status:
                    </label>
                </div>
                <div class="flex-shrink px-1 md:mb-0">
                    <label class="block capitalize tracking-wide text-gray-800 text-base font-medium">
                        {{user.marital_status}}
                    </label>
                </div>

            </div>

       <!-- <div class=" mx-3 flex w-auto justify-start">
           <button class="bg-blue-500 hover:bg-green-700 text-white
           text-sm font-semibold px-10 py-2 mt-6 rounded-sm shadow-md" @click="navToEdit">Edit info</button>
       </div> -->

        </div>





    </div>
</template>

<style scoped>

</style>

<script>
    import axios from 'axios';
    import {ArrowLeftIcon} from 'vue-feather-icons';
    // import router from '../../routes';

    export default {
        name: "user-details",
        components: {ArrowLeftIcon},
        // props: {userType: String},
        data: function(){
            return {
                user: {},
                loading: false,
            };
        },

        methods: {
            // navToEdit: function(){
            //     this.$router.push('/edit_acct');
            // },

            getUserDetail: function(){
              let token = localStorage.getItem('token');
              let id = this.$route.params.id;
            //   console.log(id);
              this.loading = true;
              if(token === null){
                  
                  this.$router.push('/');
                  this.$swal('Kindly login');
              }else{
                  axios.get(`/api/users/${id}`,
                      {headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`}}
                  ).then(response => {
                      this.loading = false;
                    if(response.data.status){
                        this.user = response.data.data;
                    }
                  })
              }
            },

            goBack(){
                this.$router.back();
            }
        },

        created() {
            this.getUserDetail();
        }


    }
</script>
